/**
 * Meet Our Client - Draggable slider with staggered "chase" effect
 * Reveal handled by scrollReveal.js (js-reveal class)
 * Each column follows with increasing delay, creating a spread-then-regroup motion
 */
(function () {
  var section = document.querySelector('.meet-client');
  if (!section) return;

  // --- Draggable slider with chase effect ---
  var slider = section.querySelector('.meet-client__slider');
  var cols = section.querySelectorAll('.meet-client__col');
  var scrollbarTrack = section.querySelector('.meet-client__scrollbar-track');
  var thumb = section.querySelector('.meet-client__scrollbar-thumb');

  if (!slider || !scrollbarTrack || !thumb || !cols.length) return;

  var targetX = 0;
  var isDraggingSlider = false;
  var isDraggingThumb = false;
  var dragStartX = 0;
  var dragStartLeft = 0;
  var colPositions = [];
  var isAnimating = false;
  var velocity = 0;
  var lastDragX = 0;
  var lastDragTime = 0;
  var momentumAnim = null;

  // Each column has a different easing speed - first col fast, last col slow
  // This creates the "chase" / "spread then regroup" effect
  function getColSpeed(index) {
    // First col: 0.18, gradually slower, last col: ~0.04
    return 0.18 - (index / cols.length) * 0.14;
  }

  function getTotalWidth() {
    var total = 0;
    for (var i = 0; i < cols.length; i++) {
      total += cols[i].offsetWidth;
    }
    var gap = cols.length > 1 ? 20 : 0; // match CSS gap
    return total + gap * (cols.length - 1);
  }

  function getMaxScroll() {
    return Math.max(0, getTotalWidth() - slider.clientWidth);
  }

  function getThumbMax() {
    return scrollbarTrack.clientWidth - thumb.clientWidth;
  }

  function updateThumb() {
    var max = getMaxScroll();
    var thumbMax = getThumbMax();
    if (max <= 0) return;
    // Use first column position as reference for thumb
    var ratio = (colPositions[0] || 0) / max;
    thumb.style.left = (ratio * thumbMax) + 'px';
  }

  function animate() {
    var stillMoving = false;

    for (var i = 0; i < cols.length; i++) {
      var diff = targetX - colPositions[i];
      if (Math.abs(diff) > 0.3) {
        colPositions[i] += diff * getColSpeed(i);
        stillMoving = true;
      } else {
        colPositions[i] = targetX;
      }
      cols[i].style.transform = 'translateX(' + (-colPositions[i]) + 'px)';
    }

    updateThumb();

    if (stillMoving) {
      requestAnimationFrame(animate);
    } else {
      isAnimating = false;
    }
  }

  function setTarget(x) {
    var max = getMaxScroll();
    targetX = Math.max(0, Math.min(x, max));
    if (!isAnimating) {
      isAnimating = true;
      requestAnimationFrame(animate);
    }
  }

  // Init all positions to 0
  for (var i = 0; i < cols.length; i++) {
    colPositions[i] = 0;
  }

  // --- Slider drag ---
  slider.addEventListener('mousedown', function (e) {
    isDraggingSlider = true;
    dragStartX = e.clientX;
    dragStartLeft = targetX;
    lastDragX = e.clientX;
    lastDragTime = Date.now();
    velocity = 0;
    if (momentumAnim) cancelAnimationFrame(momentumAnim);
    slider.style.cursor = 'grabbing';
    e.preventDefault();
  });

  slider.addEventListener('touchstart', function (e) {
    isDraggingSlider = true;
    dragStartX = e.touches[0].clientX;
    dragStartLeft = targetX;
    lastDragX = e.touches[0].clientX;
    lastDragTime = Date.now();
    velocity = 0;
    if (momentumAnim) cancelAnimationFrame(momentumAnim);
  }, { passive: true });

  function onMove(clientX) {
    if (isDraggingSlider) {
      var now = Date.now();
      var dx = dragStartX - clientX;
      velocity = (clientX - lastDragX) / Math.max(1, now - lastDragTime);
      lastDragX = clientX;
      lastDragTime = now;
      setTarget(dragStartLeft + dx);
    }
    if (isDraggingThumb) {
      var rect = scrollbarTrack.getBoundingClientRect();
      var thumbMax = getThumbMax();
      var max = getMaxScroll();
      var pos = clientX - rect.left - thumb.clientWidth / 2;
      var ratio = Math.max(0, Math.min(pos / thumbMax, 1));
      setTarget(ratio * max);
    }
  }

  function applyMomentum() {
    if (Math.abs(velocity) < 0.01) return;
    velocity *= 0.95; // friction
    setTarget(targetX - velocity * 16);
    momentumAnim = requestAnimationFrame(applyMomentum);
  }

  document.addEventListener('mousemove', function (e) { onMove(e.clientX); });
  document.addEventListener('touchmove', function (e) {
    if (isDraggingSlider || isDraggingThumb) onMove(e.touches[0].clientX);
  }, { passive: true });

  document.addEventListener('mouseup', function () {
    if (isDraggingSlider) applyMomentum();
    isDraggingSlider = false;
    isDraggingThumb = false;
    slider.style.cursor = 'grab';
  });
  document.addEventListener('touchend', function () {
    if (isDraggingSlider) applyMomentum();
    isDraggingSlider = false;
    isDraggingThumb = false;
  });

  // --- Thumb drag ---
  thumb.addEventListener('mousedown', function (e) {
    e.preventDefault();
    e.stopPropagation();
    isDraggingThumb = true;
  });
  thumb.addEventListener('touchstart', function (e) {
    e.stopPropagation();
    isDraggingThumb = true;
  }, { passive: true });

  // --- Click on scrollbar track ---
  scrollbarTrack.addEventListener('click', function (e) {
    var rect = scrollbarTrack.getBoundingClientRect();
    var thumbMax = getThumbMax();
    var max = getMaxScroll();
    var pos = e.clientX - rect.left - thumb.clientWidth / 2;
    var ratio = Math.max(0, Math.min(pos / thumbMax, 1));
    setTarget(ratio * max);
  });
})();
